import { supabase } from './supabase';

const CHANNEL_ID = 'UCJ5v_MCY6GNUBTO8-D3XoAg'; // Cleveland Street Preachers channel ID

export async function getLiveStream() {
  try {
    // First check if there's a live stream in our database
    const { data: dbStreams, error } = await supabase
      .from('livestreams')
      .select('*')
      .eq('is_live', true)
      .limit(1);

    if (error) throw error;
    
    if (dbStreams && dbStreams.length > 0) {
      return dbStreams[0];
    }

    // If no live stream in DB, get the next scheduled service
    const nextSunday = getNextSunday();
    return {
      title: 'Sunday Service',
      description: 'Join us for our weekly Sunday service',
      youtube_id: '',
      is_live: false,
      scheduled_start: nextSunday.toISOString()
    };
  } catch (error) {
    console.error('Error fetching live stream:', error);
    // Return a default state instead of null
    const nextSunday = getNextSunday();
    return {
      title: 'Sunday Service',
      description: 'Join us for our weekly Sunday service',
      youtube_id: '',
      is_live: false,
      scheduled_start: nextSunday.toISOString()
    };
  }
}

function getNextSunday() {
  const now = new Date();
  const nextSunday = new Date(now);
  nextSunday.setDate(now.getDate() + ((7 - now.getDay()) % 7));
  nextSunday.setHours(13, 30, 0, 0); // 1:30 PM
  
  // If it's Sunday after service time, get next Sunday
  if (now.getDay() === 0 && now.getHours() >= 13 && now.getMinutes() >= 30) {
    nextSunday.setDate(nextSunday.getDate() + 7);
  }
  
  return nextSunday;
}